export const getByPath = (obj: any, path: string): any => {
  if (!obj || !path) return undefined;

  const parts = path.split(".");
  let current = obj;

  for (let i = 0; i < parts.length; i++) {
    const key = parts[i];
    const k = /^\d+$/.test(key) ? Number(key) : key;

    if (current == null || typeof current !== "object") {
      // early exit if primitive encountered before end of path
      return undefined;
    }

    current = current[k];
  }

  // fallback: if undefined and path had a dot, try last segment alone
  if (current === undefined && parts.length > 1) {
    const lastKey = parts[parts.length - 1];
    return obj[lastKey];
  }

  return current;
};
